import { ComponentChildren, createContext, h } from 'preact'
import { useContext } from 'preact/hooks'
import { useCustomContext } from '../context'
import { Locale } from '../../v1/domain'

interface TextMap {
  [s: string]: string
}

type IntlCtx = {
  locale: Locale
  modifiers: any
  messages: TextMap
}

const ReduxContext = createContext<IntlCtx>({ locale: 'nb', modifiers: undefined, messages: {} })

type Props = {
  locale: Locale
  messages: {
    nn: TextMap
    nb: TextMap
    sme: TextMap
  }
  modifiers: any
  children: ComponentChildren
}

export function IntlProvider(props: Props) {
  const { locale, messages, modifiers } = this.props
  return (
    <ReduxContext.Provider value={{ locale, messages: messages[locale], modifiers }}>
      {props.children}
    </ReduxContext.Provider>
  )
}

export function useIntlContext(): IntlCtx {
  return useContext(ReduxContext)
}

export function useLocale() {
  const ctx = useContext(ReduxContext)
  return ctx.locale
}

export function useLocalizedValue() {
  const locale = useLocale()
  const { sendError } = useCustomContext()

  return (value: any) => {
    if (typeof value === 'string') {
      return value
    } else if (value && value.nb) {
      return value[locale] || value.nb
    } else {
      sendError('Ukjent verdi sendt til useLocalizedValue: ' + JSON.stringify(value))
      return '??? ukjent ???'
    }
  }
}
